export const Logo = ({ size = 26 }) => (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true">
        <defs>
            <linearGradient id="rd-mark" x1="6" y1="26" x2="26" y2="6" gradientUnits="userSpaceOnUse">
                <stop stopColor="#00C2FF" />
                <stop offset="1" stopColor="#8B5CF6" />
            </linearGradient>
        </defs>
        <path d="M9 23 23 9" stroke="url(#rd-mark)" strokeWidth="3.4" strokeLinecap="round" />
        <circle cx="10.5" cy="10.5" r="3.8" stroke="url(#rd-mark)" strokeWidth="2.8" />
        <circle cx="21.5" cy="21.5" r="3.8" stroke="url(#rd-mark)" strokeWidth="2.8" />
    </svg>
);
